const resource = '/admin/v1/plans';

export default $axios => ({
  index(page) {
    return $axios.get(`${resource}?page=${page}`);
  },

  getPublicPlans() {
    return $axios.get(`${resource}/get-public-plans`);
  },

  show(id) {
    return $axios.get(`${resource}/${id}`);
  },

  create(payload) {
    return $axios.post(`${resource}`, payload);
  },

  update(id, payload) {
    return $axios.put(`${resource}/${id}`, payload);
  },

  delete(id) {
    return $axios.delete(`${resource}/${id}`);
  }
});
